// Wat de conflictenlijst bij één twijfelgeval zegt, en welke keuzes er zijn.
//
// De keuzes volgen wat resolveAddressMatch (functions/) toestaat: 'Nieuw
// traject' alleen bij een herstart op een afgerond adres. Een onbekende reden
// krijgt alleen 'negeren' — liever geen knop dan een keuze die de server
// weigert of die het verkeerde doet.
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

/**
 * @typedef {object} AddressMatchDoc
 * @property {'questionnaire'|'intake'} Source
 * @property {string} Reason
 * @property {{Postcode: string, Huisnummer: string, Toevoeging: string}} Address
 * @property {{Straatnaam?: string, Woonplaats?: string}} [Location]
 */

/**
 * @typedef {'new-traject'|'create'|'link'|'ignore'} MatchAction
 */

/**
 * @param {AddressMatchDoc} match
 * @returns {{reason: string, actions: MatchAction[], needsHousehold: boolean}}
 */
const describeAddressMatch = (match) => {
    const wat = match?.Source === 'intake' ? 'een nieuwe aanmelding' : 'een nieuwe voormeting'

    switch (match?.Reason) {
        case 'completed-restart':
            return {
                reason: `Dit adres staat op Afgerond en er kwam ${wat} binnen.`,
                actions: ['new-traject', 'ignore'],
                needsHousehold: false,
            }
        case 'multiple-running':
            return {
                reason: 'Op dit adres staan meerdere lopende huishoudens. Kies bij welk de invulling hoort.',
                actions: ['link', 'ignore'],
                needsHousehold: true,
            }
        case 'no-household':
            return {
                reason: 'Er kwam een latere meting binnen voor een adres dat nog geen huishouden heeft.',
                actions: ['link', 'create', 'ignore'],
                needsHousehold: true,
            }
        case 'address-not-found':
            return {
                reason: 'Dit adres staat niet in het adressenregister; de invuller gaf aan dat het klopt.',
                actions: ['link', 'create', 'ignore'],
                needsHousehold: true,
            }
        default:
            return { reason: `Onbekende reden (${match?.Reason || ''}).`, actions: ['ignore'], needsHousehold: false }
    }
}

/**
 * Het adres zoals de lijst het toont: met straat en plaats als PDOK ze kende,
 * anders zoals het ingevuld werd.
 * @param {AddressMatchDoc} match
 * @returns {string}
 */
const addressText = (match) => {
    const a = match?.Address || {}
    const nummer = `${a.Huisnummer || ''}${a.Toevoeging || ''}`
    const straat = match?.Location?.Straatnaam
    if (straat) {
        const plaats = [a.Postcode, match.Location.Woonplaats].filter(Boolean).join(' ')
        return `${straat} ${nummer}, ${plaats}`
    }
    return `${a.Postcode || ''} ${nummer}`.trim()
}

export { addressText }
export default describeAddressMatch
